const STORAGE_KEY = 'trainingId';

const session = (): Storage | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const readStoredTrainingId = (): string | null => {
  try {
    return session()?.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
};

export const storeTrainingId = (trainingId: string): void => {
  try {
    session()?.setItem(STORAGE_KEY, trainingId);
  } catch {
  }
};

export const clearStoredTrainingId = (): void => {
  try {
    session()?.removeItem(STORAGE_KEY);
  } catch {
  }
};
